exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-danger-text{color:#d9534f}@keyframes blink{0%,to{opacity:1}50%{opacity:0}}.blink{animation:blink 1s infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42842bf2","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/viewAllModuleDetails.vue
// module id = 1540
// module chunks = 0